import OnlineAppComponent from "../lib/online_app_component";
import {getThrottledFunction} from "../../helpers/throttle";

export const OnlineAppHeaderConfig = {
    baseHtmlClass: 'online_app__main__header',
    selector: '.online_app__main__header',

    itemElementSelector: '.online_app__main__header__items',
}

export class OnlineAppHeader extends OnlineAppComponent {

    static get config() {
        return OnlineAppHeaderConfig;
    }

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppHeader.config);
        this.itemsElement = this.element.querySelector(OnlineAppHeader.config.itemElementSelector);
        const resizeHandler = getThrottledFunction(this.handleResize.bind(this), 100);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(this.element);
    }

    handleResize() {
        this.conditionallySetHtmlClassState(this.isDisplaced(), "displaced");
    }

    render() {
        this.conditionallySetHtmlClassState(this.isDisplaced(), "displaced");
        setTimeout(()=>{
            const horizSpace = (!!this.onlineApp.nav) ? this.onlineApp.nav.getHorizSpace() : 0;
            this.element.style.left = `${ horizSpace }px`;
        },500); // The >=500ms delay in important to allow the nav to complete moving/rendering.
    }

    // This is "displaced" when its internal content is wider than the header itself (plus a margin).
    isDisplaced() {
        return this.getContentWidth() > this.getInnerWidth();
    }

    getInnerWidth() {
        const style = getComputedStyle(this.element);
        return parseInt(style.width, 10) - parseInt(style.paddingLeft, 10) - parseInt(style.paddingRight, 10);
    }

    getContentWidth() {
        return this.itemsElement.offsetWidth + 25; // Include a 25px margin for good measure.
    }

}

export function getHeader(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppHeader(element, onlineApp);
}
